module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/agent-details/agent-details.component.css
// module id = ./src/app/sendMoney/agent-details/agent-details.component.css
// module chunks = main